// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { UserAuthState } from '@interfaces/user.interfaces';
import { Observable } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import { UserService } from '@services/user.service';
import { RouteGuardService } from '@services/route-guard.service';

@Injectable({
    providedIn: 'root',
})
export class CustomerGuard implements CanActivate {
    constructor(
        private readonly userService: UserService,
        private readonly routeGuardService: RouteGuardService,
        private readonly router: Router
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.userService.userState$().pipe(
            filter((userState) => userState === UserAuthState.userLoaded),
            map(() => this.userService.isCustomer),
            tap(async (canActivate) => {
                this.routeGuardService.logRouteGuard(this.constructor.name, canActivate);

                if (!canActivate) {
                    // this is not a customer user... redirect to the login page
                    await this.router.navigate(['/login']);
                }
            })
        );
    }
}
